import { Typography, ListItemText } from '@mui/material';

import makeStyles from '@mui/styles/makeStyles';

import { ReactComponent as BookmarkOutlinedIcon } from '../Icons/Bookmark-fill.svg';
import ClickAwayListener from '@mui/material/ClickAwayListener';
import { ReactComponent as CloseIcon } from '../Icons/close.svg';
import { ReactComponent as MenuIcon } from "../Icons/menu.svg";
import MenuItem from '@mui/material/MenuItem';
import MenuList from '@mui/material/MenuList';
import React, { useRef, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { generatePathMyList } from '../Utils/Routes';
import EscapeListener from './Utils/EscapeListener';
// import { ContactsSharp } from '@mui/icons-material';
import TabAwayListener from './Utils/TabAwayListener';
import { useActiveAwards } from '../Utils/Award';
import BasicButton from './Buttons/BasicButton';

const useStyles = makeStyles((theme) => ({
    menuWrap: {
        background: theme.palette.secondary.main,
        position: "absolute",
        zIndex: 10,
        border: '1px solid #333333',
        boxSizing: "border-box",
        left: theme.spacing(2),
        right: theme.spacing(2),

        [theme.breakpoints.up('md')]: {
            maxWidth: 600,
            margin: theme.spacing(-3),
            left: 'unset',
            right: 'unset',
        },
    },
    myListButton: {
        padding: theme.spacing(1),
        border: '1px solid transparent',
        
        '& .MuiTypography-h6': {
            lineHeight: '24px'
        },
        '& svg': {
            marginRight: theme.spacing(2),
            width: '24px',
            height: '24px'
        },
        '& svg path': {
            fill: theme.palette.primary.main,
        },
        "&:hover": {
            backgroundColor: "transparent",
        },
        "$menuWrap &": {
            padding: theme.spacing(4),
            borderWidth: 0,
        }
    },
    menuOpenContent: {
        zIndex: 1,
        padding: `0 ${theme.spacing(4)}`,
    },
    awardHeading: {
    },
    menuList: {
    },
    awardLink: {
        color: theme.palette.secondary.light,
        backgroundColor: 'rgba(255, 255, 255, 0.05)',
        fontSize: '14px',
        fontWeight: theme.typography.fontWeightBold,
        lineHeight: '16px',
        letterSpacing: '1.25px',
        background: '#343434',
        whiteSpace: "unset",
        wordBreak: "break-word",

        display: 'flex',
        alignItems: 'center',
        padding: `${theme.spacing(2)} ${theme.spacing(2)}`,
        marginTop: theme.spacing(2),
        marginBottom: theme.spacing(4),
        textDecoration: 'none',
        border: '1px solid transparent',
        
        '&:hover': {
            background: theme.palette.secondary.black,
            color: theme.palette.secondary.contrastText
        },
        '&:active': {
            color: theme.palette.primary.main,
            border: '1px solid',
        },

        '& svg': {
            marginRight:'10px',
            "& path": {
                fill:'currentColor',
            }
        },
    },
    awardLinkActive: {
        color: theme.palette.primary.main,
        borderColor: 'currentColor',
        background: theme.palette.secondary.black,

        '&:hover': {
            color: theme.palette.primary.light,
        },
    },
}));

export default function AwardListMenu({ currentAward, showMyList, currentFixedCategories = [] }) {
    const classes = useStyles();
    const [open, setOpen] = React.useState(false);

    const awards = useActiveAwards()?.sort((a, b) => {
        let titleA = a.title.replace(/\s/g, '').toUpperCase();
        let titleB = b.title.replace(/\s/g, '').toUpperCase();
        return titleA.localeCompare(titleB);
    });

    const menuCloseButtonRef = useRef(null);
    const menuOpenButtonRef = useRef(null);
    const myListRef = useRef(null);
    const handleToggle = () => {
        if(menuOpenButtonRef.current) 
            menuOpenButtonRef.current.focus();
        setOpen((prevOpen) => !prevOpen);
    };

    useEffect(() => {
        if (open && menuCloseButtonRef.current) {
            menuCloseButtonRef.current.focus();
        } else if (menuCloseButtonRef.current) {
            menuOpenButtonRef.current.focus();
        }
    }, [open]);

    const handleClose = () => {
        setOpen(false);
    };

    const heading = 
        currentFixedCategories && currentFixedCategories.length
            ? currentFixedCategories[0].title
            : (
                currentAward 
                    ? currentAward.title
                    : "My List"
            )
    ;

    return (
        <ClickAwayListener disableReactTree={false} onClickAway={() => { open && handleClose() }}>
            <div>
                <EscapeListener enabled={open} onKeyPress={() => {
                    if(menuOpenButtonRef.current) 
                        menuOpenButtonRef.current.focus();
                    setOpen(false);
                }}>
                    <TabAwayListener tabRef={myListRef} enabled={open} tabAwayHandler={() => setOpen(false)}>
                        {open && (
                            <div
                                className={classes.menuWrap}
                                aria-label="Menu"
                                aria-controls={open ? 'menu-list-grow' : undefined}
                                aria-haspopup="true"
                                ref={myListRef}
                            >
                                <BasicButton 
                                    className={classes.myListButton}
                                    onClick={handleToggle}
                                    ref={menuCloseButtonRef}
                                >
                                    { open ? <CloseIcon /> : <MenuIcon /> }
                                    <Typography variant="h6" className="upper">{heading}</Typography>
                                </BasicButton>
                                <div className={classes.menuOpenContent}>
                                    {showMyList && (
                                        <MenuList className={classes.menuList}>
                                            <MenuItem
                                                component={Link} to={generatePathMyList()}
                                                className={["upper", classes.awardLink, !currentAward ? classes.awardLinkActive : ""].join(" ")}
                                                tabIndex={0}
                                            >
                                                <BookmarkOutlinedIcon/>
                                                <ListItemText>My List</ListItemText>
                                            </MenuItem>
                                        </MenuList>
                                    )}
                                    <Typography variant="button" className={["upper", classes.awardHeading].join(" ")}>Your Content</Typography>
                                    <MenuList className={classes.menuList}>
                                        <MenuItem 
                                            key="all-content"
                                            component={Link} 
                                            to="/"
                                            className={[
                                                "upper", 
                                                classes.awardLink
                                            ].join(" ")}
                                            tabIndex={0}
                                        >
                                            <ListItemText>All Content</ListItemText>
                                        </MenuItem>
                                        {awards.map((award) => (
                                            <MenuItem 
                                                key={award.awardId}
                                                component={Link} 
                                                to={ award.urlNextTo } 
                                                className={[
                                                    "upper", 
                                                    classes.awardLink, 
                                                    currentAward && currentAward.awardId === award.awardId ? classes.awardLinkActive : "",
                                                ].join(" ")}
                                                tabIndex={0}
                                            >
                                                <ListItemText>{award.title}</ListItemText>
                                            </MenuItem>
                                        ))}
                                    </MenuList>
                                </div>
                            </div>
                        )}
                        <div>
                            <BasicButton 
                                className={classes.myListButton}
                                onClick={handleToggle}
                                ref={menuOpenButtonRef}
                            >
                                { open ? <CloseIcon /> : <MenuIcon /> }
                                <Typography variant="h6" className="upper">{heading}</Typography>
                            </BasicButton>
                        </div>
                    </TabAwayListener>
                </EscapeListener>
            </div>
        </ClickAwayListener>
    );
}
